export const I18nPrefix = 'strava.accounts.summary';

export default { I18nPrefix };
